/*
 * Utility that calls PXP with a given Page Name
 *
 *
 * REQUIRED FILES:
 *	jquery-1.7.1.min.js
 *
 */
define(['jquery', 'backbone'], function($, Backbone) {
	function callRoute(pxpKey, callBack) {
		// Ajax call to PXP route
		$.ajax({
			type: 'GET',
			url: Backbone.history.options.root + 'pxpPageData?pxpKey=' + pxpKey,
			success: function (response) {
				var experimentData = response || {};
				callBack(experimentData);
			},
			error: function (error) {
				var experimentData = {};
				callBack(experimentData);
			},
			ignoreErrors: true
		});
	}
	return {
		callRoute: callRoute
	};
});



//////////////////
// WEBPACK FOOTER
// ./lib/pxpHelper.js
// module id = 862
// module chunks = 0